import { render } from "./LocationTitle.vue?vue&type=template&id=f87eb0a6"
import script from "./LocationTitle.vue?vue&type=script&lang=js"
export * from "./LocationTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__